/**
 * Custom email / SMS template slot configuration for the account
 * communications section.
 *
 * Ported 1:1 from the legacy
 * `_legacy/components/Accounts/Item/AccountForm/widgets/CustomEmailSection/constants.js`.
 * The `survey`-prefixed `rowNameFirst` values and `*Survey*` field
 * names are legacy Formik / API identifiers and stay as-is until a
 * separate backend migration renames them — user-facing copy that
 * labels these slots already reads "Assessment" via i18n.
 *
 * `configKey` / `topicKey` are where this slot lives in the API's
 * nested template payloads — both the account's own
 * `emailConfiguration.surveyInvitation` and the system defaults from
 * `GET /accounts/default-text` use that two-level shape, with the
 * English and Spanish texts sharing one array.
 */
export const CUSTOM_EMAIL_SECTION_FIELDS = [
  {
    rowNameFirst: 'survey',
    rowNameSecond: 'invitationEmail',
    configKey: 'emailConfiguration',
    topicKey: 'surveyInvitation',
    firstFieldName: 'emailSurveyInvitationEnglish',
    secondFieldName: 'emailSurveyInvitationSpanish',
    idDefaultName: 'emailSurveyInvitationIsDefault',
  },
  {
    rowNameFirst: 'resource',
    rowNameSecond: 'invitationEmail',
    configKey: 'emailConfiguration',
    topicKey: 'resourceInvitation',
    firstFieldName: 'emailResourceInvitationEnglish',
    secondFieldName: 'emailResourceInvitationSpanish',
    idDefaultName: 'emailResourceInvitationIsDefault',
  },
  {
    rowNameFirst: 'survey',
    rowNameSecond: 'invitationSMS',
    configKey: 'smsConfiguration',
    topicKey: 'surveyInvitation',
    firstFieldName: 'smsSurveyInvitationEnglish',
    secondFieldName: 'smsSurveyInvitationSpanish',
    idDefaultName: 'smsSurveyInvitationIsDefault',
  },
  {
    rowNameFirst: 'resource',
    rowNameSecond: 'invitationSMS',
    configKey: 'smsConfiguration',
    topicKey: 'resourceInvitation',
    firstFieldName: 'smsResourceInvitationEnglish',
    secondFieldName: 'smsResourceInvitationSpanish',
    idDefaultName: 'smsResourceInvitationIsDefault',
  },
  {
    rowNameFirst: 'survey',
    rowNameSecond: 'reminderEmail',
    configKey: 'emailConfiguration',
    topicKey: 'surveyReminder',
    firstFieldName: 'emailSurveyReminderEnglish',
    secondFieldName: 'emailSurveyReminderSpanish',
    idDefaultName: 'emailSurveyReminderIsDefault',
  },
  {
    rowNameFirst: 'resource',
    rowNameSecond: 'reminderEmail',
    configKey: 'emailConfiguration',
    topicKey: 'resourceReminder',
    firstFieldName: 'emailResourceReminderEnglish',
    secondFieldName: 'emailResourceReminderSpanish',
    idDefaultName: 'emailResourceReminderIsDefault',
  },
  {
    rowNameFirst: 'survey',
    rowNameSecond: 'reminderSMS',
    configKey: 'smsConfiguration',
    topicKey: 'surveyReminder',
    firstFieldName: 'smsSurveyReminderEnglish',
    secondFieldName: 'smsSurveyReminderSpanish',
    idDefaultName: 'smsSurveyReminderIsDefault',
  },
  {
    rowNameFirst: 'resource',
    rowNameSecond: 'reminderSMS',
    configKey: 'smsConfiguration',
    topicKey: 'resourceReminder',
    firstFieldName: 'smsResourceReminderEnglish',
    secondFieldName: 'smsResourceReminderSpanish',
    idDefaultName: 'smsResourceReminderIsDefault',
  },
  {
    rowNameFirst: 'survey',
    rowNameSecond: 'completionEmail',
    configKey: 'emailConfiguration',
    topicKey: 'surveyCompletion',
    firstFieldName: 'emailSurveyCompletionEnglish',
    secondFieldName: 'emailSurveyCompletionSpanish',
    idDefaultName: 'emailSurveyCompletionIsDefault',
  },
  {
    rowNameFirst: 'survey',
    rowNameSecond: 'completionSMS',
    configKey: 'smsConfiguration',
    topicKey: 'surveyCompletion',
    firstFieldName: 'smsSurveyCompletionEnglish',
    secondFieldName: 'smsSurveyCompletionSpanish',
    idDefaultName: 'smsSurveyCompletionIsDefault',
  },
];
